import React from 'react';
import FormInventorySection from '../../../sections/AdminDashboard/FormInventory/FormInventory';

const FormInventory = () => <FormInventorySection />;

export default FormInventory;
